export default {
    targetSetType: {
        defaults: {
            endpoint: 'targetSetTypes.php'
        },
        read: {
            params: { action: 'get' }
        },
        create: {
            params: { action: 'create' },
        },
        update: {
            params: { action: 'update' },
        },
        destroy: {
            params: { action: 'delete' },
        }
    }
}